
/* injects from baggage-loader */

'use strict';

function runBlock($log, $rootScope, $timeout, $window, $location, $transitions, Parse, User, Alerts, ErrorHandler, Navigation, DEFAULT_PAGE_TITLE) {
	'ngInject';

	// NOTE: TEMPALTE REPLACEMENT HANDLED BY WEBPACK, DON'T EDIT MANUALLY
	// Initialize parse with Application key only
	Parse.initialize('neighbor-funds');

	// NOTE: TEMPALTE REPLACEMENT HANDLED BY WEBPACK, DON'T EDIT MANUALLY
	// Set server URL
	Parse.serverURL = 'https://api.neighborfunds.com/parse';

	// Create the main application state
	$rootScope.appState = {
		current: {},				// Hold the current state
		transitions: {}
	};

	// State animation settings
	// Remove class name or set false to disable
	$rootScope.state_transitions = {
		main: false,	//'state-transition-slide',
		child: false
	};

	// Refresh current user

	// Set UI Router error handler
	$transitions._router.stateService.defaultErrorHandler(function (error) {
		/* ignore routing errors */
		$log.error(error);

		if (typeof error.detail !== 'undefined') {
			// $log.error('Error code:', error.detail.code);
			// $log.error('Error msg:', error.detail.message);

			// Pass it to the error handler
			ErrorHandler(error.detail);

		}

	});


	// =========================================
	// Global Transition Hooks
	// =========================================


	// Called when any state transition is about to begin
	$transitions.onStart({}, transition => {
		// Do stuff when the state transition begins

		// Show the loading bar
		let current_state = transition._targetState._definition;
		if (current_state.resolvables.length) {
			$rootScope.loading_state = true;
		}

		// Listen for notifying transitions
		if (transition.options().notify !== false) {

			// Check if to state is set as previous in state data
			let previous = transition.from().data ? transition.from().data.previous : '';

			// Update state transition flags
			$rootScope.appState.transitions.back = transition.to().name === previous;
			$rootScope.appState.transitions.toHome = (transition.to().name === 'home');

		}

		// Redirect to login page if route is protected and no current user
		if (transition.to().protected === true && User.isUserLoggedIn() === false) {

			// Grab the intended path and save it
			// Navigation.setIntendedPath($location.path());

			// Add alert to what happened to global alerts
			Alerts.add({
				type: 'info',
				msg: 'Please log in to perform this action.',
				timeout: 60000
			});

			$location.path('/account/login?ref=' + transition.to().name);
			return transition.router.stateService.target('login', { ref: transition.to().name });
		}

	});

	// Called when any state transition is entered
	$transitions.onEnter({}, transition => {

		// Clear any local alerts
		Alerts.clearLocal();

		// Un-hide the header incase it's been hidden by the previous state
		$rootScope.appState.hideHeader = false;

		// Re-lock the header incase it's been modified by the previous state
		$rootScope.appState.unlockHeader = false;

		// Un-hide the footer incase it's been hidden by the previous state
		$rootScope.appState.hideFooter = false;

		$rootScope.appState.transparentHeader = false;
		$rootScope.appState.animateHeader = false;

		// Set the current state
		$rootScope.appState.current = transition.to();
		// $log.log($rootScope.appState.current)

		if (transition.to().transparent_nav) {
			$rootScope.appState.transparentHeader = true;
			$rootScope.appState.animateHeader = true;
		}

		// MOVED TO $transitions.onStart HOOK 
		// $log.log('Protected:', transition.to().protected);
		// $log.log('User:', User.isUserLoggedIn())

		// // Redirect to login page if route is protected and no current user
		// if (transition.to().protected === true && User.isUserLoggedIn() === false) {

		// 	// Grab the intended path and save it
		// 	// Navigation.setIntendedPath($location.path());

		// 	// Add alert to what happened to global alerts
		// 	Alerts.add({
		// 		type: 'info',
		// 		msg: 'Please log in to perform this action.',
		// 		timeout: 60000
		// 	});

		// 	$location.path('/login');
		// 	return transition.router.stateService.target('login');
		// }

	});

	// Called when any state transition succeeds
	$transitions.onSuccess({}, transition => {

		// Hide loading bar
		$timeout(() => {
			$rootScope.loading_state = false;
		}, 250);

		// Always scroll to the top of the page on route change
		$window.scrollTo(0, 0);

		// Update document title
		$timeout(() => {
			if (typeof transition.to().title !== 'undefined' && transition.to().title.length > 0) {
				// Set document title for the current page
				$window.document.title = `${DEFAULT_PAGE_TITLE} | ${transition.to().title}`;
			} else {
				// Set the default page title
				$window.document.title = DEFAULT_PAGE_TITLE;
			}
		}, 250);

	});

	// Called when any state transition encounters an error
	$transitions.onError({}, (transition, state) => {
		// Handle transition errors

		// Remove the loading bar
		// Hide loading bar
		$timeout(() => {
			$rootScope.loading_state = false;
		}, 250);

	});

	
	// ============================================
	// User setup
	// ============================================

	// Fetch user roles
	// User.fetchRoles()
		// .then(roles => {
		// 	$log.log('Is Admin:', User.hasRole('Admins'))
		// })

}

export default runBlock;


// WEBPACK FOOTER //
// ./src/app/index.run.js